import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToolbarService {
  tableCreationToggled$ = new BehaviorSubject<boolean>(false);

  setTableCreationEnabled(toggled: boolean): void {
    this.tableCreationToggled$.next(toggled);
  }

  isTableCreationEnabled(): boolean {
    return this.tableCreationToggled$.value;
  }
}
